import Link from "./Link"
import Image from "./Image"

function EmailFormated({ username, domain, at = "@" }) {
    return (
            <>
                { username }
                { at }
                { domain }
            </>
        )
}

export default function Email({ email }) {
    const [username, domain] = email.split("@")

    return (
        <Link
            href="email"
            params={ {email: email} }
        >
            <i>
                <Image
                    src="email"
                    alt="E-Mail"
                />
            </i>
            <EmailFormated
                username={username}
                domain={domain}
                at={
                    <Image 
                        src="at"
                        alt="@"
                    />
                }
            />
        </Link>
    )
}